import React from 'react';

const t = {
  ontime: 'On time rate',
};

const ontimeRateToPercentage = (ontime) => {
  if (!ontime) return '';

  const ontimePercentage = parseInt(parseFloat(ontime) * 100);

  return `${ontimePercentage}%`;
};

const Ontime = ({ onTimeRate }) => {
  if (!onTimeRate) return null;
  return (
    <>
      {t.ontime}: <strong>{ontimeRateToPercentage(onTimeRate)}</strong>
    </>
  );
};

export default Ontime;
